import { render, staticRenderFns } from "./dispatchOrderDetail.vue?vue&type=template&id=a899c610&"
import script from "./dispatchOrderDetail.vue?vue&type=script&lang=js&"
export * from "./dispatchOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./dispatchOrderDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports